<div class="modal" style="background-color: rgba(255, 255, 255, 0.75)" [style.display]="progress ? 'block' : 'none'" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content" (click)="progress = false">
            <div class="modal-body" style="padding: 1px">
                <div class="progress">
                    <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" style="width: 100%"></div>
                </div>
            </div>
        </div>
    </div>
</div>